import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a82de11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "timer" }
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "colon" }, ":", -1))
const _hoisted_6 = { class: "timer" }
const _hoisted_7 = ["value", "disabled"]

import { computed, onUnmounted, ref } from 'vue'
import { fillDigit } from '@/utils/common'

import MoveablePanel from '@/components/MoveablePanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountdownTimer',
  props: {
  left: {
    type: Number,
    default: 5,
  },
  top: {
    type: Number,
    default: 5,
  },
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {





const timer = ref<number | null>(null)
const inTiming = ref(false)
const isCountdown = ref(false)
const time = ref(0)
const minute = computed(() => Math.floor(time.value / 60))
const second = computed(() => time.value % 60)

const inputEditable = computed(() => {
  return !isCountdown.value || inTiming.value
})

const clearTimer = () => {
  if (timer.value) clearInterval(timer.value)
}

onUnmounted(clearTimer)

const pause = () => {
  clearTimer()
  inTiming.value = false
}

const reset = () => {
  clearTimer()
  inTiming.value = false
  
  if (isCountdown.value) time.value = 600
  else time.value = 0
}

const start = () => {
  clearTimer()

  if (isCountdown.value) {
    timer.value = setInterval(() => {
      time.value = time.value - 1

      if (time.value <= 0) reset()
    }, 1000)
  }
  else {
    timer.value = setInterval(() => {
      time.value = time.value + 1

      if (time.value > 36000) pause()
    }, 1000)
  }

  inTiming.value = true
}

const toggle = () => {
  if (inTiming.value) pause()
  else start()
}

const toggleCountdown = () => {
  isCountdown.value = !isCountdown.value
  reset()
}

const changeTime = (e: FocusEvent | KeyboardEvent, type: 'minute' | 'second') => {
  const inputRef = e.target as HTMLInputElement
  let value = inputRef.value
  const isNumber = /^(\d)+$/.test(value)
  if (isNumber) {
    if (type === 'second' && +value >= 60) value = '59'
    time.value = type === 'minute' ? (+value * 60 + second.value) : (+value + minute.value * 60)
  }
  else inputRef.value = type === 'minute' ? fillDigit(minute.value, 2) : fillDigit(second.value, 2)
}

return (_ctx: any,_cache: any) => {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createBlock(MoveablePanel, {
    class: "countdown-timer",
    width: 180,
    height: 110,
    left: __props.left,
    top: __props.top
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "text-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
        }, _toDisplayString(inTiming.value ? '暂停' : '开始'), 1),
        _createElementVNode("span", {
          class: "text-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (reset()))
        }, "重置"),
        _createElementVNode("span", {
          class: _normalizeClass(["text-btn", { 'active': isCountdown.value }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleCountdown()))
        }, "倒计时", 2)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "text",
            value: _unref(fillDigit)(_unref(minute), 2),
            maxlength: 3,
            disabled: _unref(inputEditable),
            onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
            onBlur: _cache[4] || (_cache[4] = $event => changeTime($event, 'minute')),
            onKeydown: [
              _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
              _cache[6] || (_cache[6] = _withKeys(_withModifiers($event => changeTime($event, 'minute'), ["stop"]), ["enter"]))
            ]
          }, null, 40, _hoisted_4)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "text",
            value: _unref(fillDigit)(_unref(second), 2),
            maxlength: 3,
            disabled: _unref(inputEditable),
            onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
            onBlur: _cache[8] || (_cache[8] = $event => changeTime($event, 'second')),
            onKeydown: [
              _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
              _cache[10] || (_cache[10] = _withKeys(_withModifiers($event => changeTime($event, 'second'), ["stop"]), ["enter"]))
            ]
          }, null, 40, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('close')))
      }, [
        _createVNode(_component_IconClose, { class: "icon" })
      ])
    ]),
    _: 1
  }, 8, ["left", "top"]))
}
}

})